<template>
  <div class="flex flex-col max-w-6xl px-6 mx-auto mb-16 md:flex-row">
    <div class="grid gap-8 md:grid-cols-3">
      <div class="flex items-center p-4 space-x-4 text-white rounded-lg shadow-xl bg-blue-700 dark:bg-gray-700 dark:text-gray-300 transform hover:-translate-y-4 duration-300">
        <div class="p-2 text-blue-700 bg-white rounded-full dark:text-red-100 dark:bg-red-500">
          <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clip-rule="evenodd"></path>
          </svg>
        </div>
        <div>
          <h3 class="text-2xl font-semibold">Use on any device</h3>
          <p class="">Easy access on any device such as phone, tablet and laptop.</p>
        </div>
      </div>

      <div class="flex theme-dark">
        <div class="flex items-center w-full p-4 space-x-4 text-white rounded-lg shadow-xl bg-yellow-600 dark:bg-gray-700 dark:text-gray-300 transform hover:-translate-y-4 duration-300">
          <div class="p-2 text-yellow-600 bg-white rounded-full dark:text-red-100 dark:bg-red-500">
            <!-- <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
              <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"></path>
            </svg> -->
            <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" viewBox="0 0 20 20" fill="currentColor">
              <path fill="currentColor" d="M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1z" clip-rule="evenodd" />
              <path d="M11 4a1 1 0 10-2 0v1a1 1 0 002 0V4zM10 7a1 1 0 011 1v1h2a1 1 0 110 2h-3a1 1 0 01-1-1V8a1 1 0 011-1zM16 9a1 1 0 100 2 1 1 0 000-2zM9 13a1 1 0 011-1h1a1 1 0 110 2v2a1 1 0 11-2 0v-3zM7 11a1 1 0 100-2H4a1 1 0 100 2h3zM17 13a1 1 0 01-1 1h-2a1 1 0 110-2h2a1 1 0 011 1zM16 17a1 1 0 100-2h-3a1 1 0 100 2h3z" />
            </svg>
          </div>
          <div>
            <h3 class="text-2xl font-semibold">Easy by QR scan !</h3>
            <p class="">Easier link sharing with QR platform!</p>
          </div>
        </div>
      </div>

      <div class="flex items-center p-4 space-x-4 text-white rounded-lg shadow-xl bg-green-600 dark:bg-gray-700 dark:text-gray-300 transform hover:-translate-y-4 duration-300">
        <div class="p-2 text-green-600 bg-white rounded-full dark:text-red-100 dark:bg-red-500">
          <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"></path>
          </svg>
        </div>
        <div>
          <h3 class="text-2xl font-semibold">Strong API !</h3>
          <p class="">Convenience for developers with our API.</p>
        </div>
      </div>
    </div>
  </div>
</template>